export default "__VITE_ASSET__CnWqvnws__"